var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.scopevalue
    ? _c(
        _vm.wrapperTag,
        {
          tag: "component",
          class: [
            !!_vm.scopefield.configuration.container_width
              ? "sm" + _vm.scopefield.configuration.container_width + ""
              : "",
            _vm.table ? "px-0" : "xs12"
          ]
        },
        [
          _c("transition", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.visible,
                    expression: "visible"
                  }
                ],
                staticClass: "os-field-container",
                class: [
                  {
                    "os-readonly-field": _vm.scopefield.configuration.read_only
                  },
                  { "fill-height": !_vm.table }
                ]
              },
              [
                !_vm.editDisabled &&
                _vm.viewform &&
                _vm.inlineEdit &&
                _vm.scopefield.type !== "status"
                  ? _c(
                      "div",
                      { staticClass: "os-action-btns" },
                      [
                        _c(
                          "v-slide-x-reverse-transition",
                          { attrs: { mode: "out-in" } },
                          [
                            _c(
                              "div",
                              { key: "transition-" + _vm.editing },
                              [
                                !_vm.editing
                                  ? [
                                      !_vm.scopefield.configuration.read_only
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticClass:
                                                "right ma-0 os-hover-btn",
                                              class: {
                                                "os-touch-device":
                                                  _vm.touchdevice
                                              },
                                              attrs: {
                                                color: "info",
                                                text: "",
                                                icon: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  _vm.editing = true
                                                }
                                              }
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v(
                                                  "mdi-circle-edit-outline"
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ]
                                  : [
                                      _vm.inlineSave
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticClass: "ma-0",
                                              attrs: {
                                                color: "success",
                                                text: "",
                                                icon: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.saveEdit($event)
                                                }
                                              }
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v("mdi-check-outline")
                                              ])
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "ma-0",
                                          attrs: {
                                            color: "error",
                                            text: "",
                                            icon: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.cancelEdit($event)
                                            }
                                          }
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v("mdi-close-circle-outline")
                                          ])
                                        ],
                                        1
                                      )
                                    ]
                              ],
                              2
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.editDisabled ||
                (_vm.viewform &&
                  !_vm.editing &&
                  _vm.scopefield.type !== "status")
                  ? _c(
                      "div",
                      { class: { "px-2": _vm.table } },
                      [
                        !_vm.singleLine
                          ? _c("label", { staticClass: "os-dirty-label" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(_vm.keyedFields[_vm.field.id].name)
                              ),
                              _c("br")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("field-value", {
                          staticClass: "subheading",
                          attrs: { field: _vm.field, value: _vm.value }
                        }),
                        _vm._v(" "),
                        _c("div", { staticStyle: { clear: "both" } })
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        class: [
                          _vm.table
                            ? _vm.scopefield.type == "status"
                              ? "px-4"
                              : "px-2"
                            : "",
                          {
                            "os-field-editing-nosave":
                              _vm.viewform &&
                              _vm.inlineEdit &&
                              !_vm.inlineSave &&
                              _vm.editing &&
                              _vm.scopefield.type !== "status"
                          },
                          {
                            "os-field-editing-save":
                              _vm.viewform &&
                              _vm.inlineEdit &&
                              _vm.inlineSave &&
                              _vm.editing &&
                              _vm.scopefield.type !== "status"
                          }
                        ],
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                          }
                        }
                      },
                      [
                        _vm.scopefield.type === "checkbox"
                          ? [
                              _c("v-checkbox", {
                                ref: "fieldinput",
                                attrs: {
                                  label: _vm.scopefield.name,
                                  required: _vm.scopefield.required,
                                  hint: _vm.scopefield.configuration.hint_text,
                                  "persistent-hint": !!_vm.scopefield
                                    .configuration.hint_text,
                                  "prepend-icon":
                                    _vm.scopefield.configuration.icon,
                                  rules: [_vm.rules.required],
                                  readonly:
                                    _vm.scopefield.configuration.read_only,
                                  "append-icon": _vm.scopefield.configuration
                                    .read_only
                                    ? "lock"
                                    : null
                                },
                                model: {
                                  value: _vm.scopevalue.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.scopevalue, "value", $$v)
                                  },
                                  expression: "scopevalue.value"
                                }
                              })
                            ]
                          : _vm.scopefield.type === "date"
                          ? [
                              !_vm.scopefield.configuration.current_selection
                                ? _c(
                                    "v-menu",
                                    {
                                      ref: "menu",
                                      attrs: {
                                        transition: "scale-transition",
                                        "offset-y": "",
                                        "min-width": "290px",
                                        "close-on-content-click": false
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              return [
                                                _c(
                                                  "v-text-field",
                                                  _vm._g(
                                                    {
                                                      ref: "fieldinput",
                                                      attrs: {
                                                        readonly: "",
                                                        clearable:
                                                          !_vm.scopefield
                                                            .required &&
                                                          !_vm.scopefield
                                                            .configuration
                                                            .read_only,
                                                        label:
                                                          _vm.scopefield.name,
                                                        required:
                                                          _vm.scopefield
                                                            .required,
                                                        hint:
                                                          _vm.scopefield
                                                            .configuration
                                                            .hint_text,
                                                        "persistent-hint": !!_vm
                                                          .scopefield
                                                          .configuration
                                                          .hint_text,
                                                        prefix:
                                                          _vm.scopefield
                                                            .configuration
                                                            .prefix,
                                                        "prepend-icon":
                                                          _vm.scopefield
                                                            .configuration.icon,
                                                        suffix:
                                                          _vm.scopefield
                                                            .configuration
                                                            .suffix,
                                                        rules: [
                                                          _vm.rules.required
                                                        ],
                                                        "single-line":
                                                          _vm.singleLine,
                                                        "append-icon": _vm
                                                          .scopefield
                                                          .configuration
                                                          .read_only
                                                          ? "lock"
                                                          : null
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.scopevalue.value,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.scopevalue,
                                                            "value",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scopevalue.value"
                                                      }
                                                    },
                                                    on
                                                  )
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        4203216132
                                      ),
                                      model: {
                                        value: _vm.datemenu,
                                        callback: function($$v) {
                                          _vm.datemenu = $$v
                                        },
                                        expression: "datemenu"
                                      }
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("v-date-picker", {
                                        attrs: {
                                          "no-title": "",
                                          scrollable: ""
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.datemenu = false
                                          }
                                        },
                                        model: {
                                          value: _vm.scopevalue.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.scopevalue,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "scopevalue.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : [
                                    _c("v-autocomplete", {
                                      ref: "fieldinput",
                                      attrs: {
                                        "search-input":
                                          _vm.autocompleteSearchText,
                                        items: [
                                          {
                                            text: "Day",
                                            value: "day"
                                          },
                                          {
                                            text: "Week",
                                            value: "week"
                                          },
                                          {
                                            text: "Month",
                                            value: "month"
                                          },
                                          {
                                            text: "Quarter",
                                            value: "quarter"
                                          },
                                          {
                                            text: "Year",
                                            value: "year"
                                          }
                                        ],
                                        label: _vm.scopefield.name,
                                        required: _vm.scopefield.required,
                                        "single-line": _vm.singleLine,
                                        clearable:
                                          !_vm.scopefield.required &&
                                          !_vm.scopefield.configuration
                                            .read_only,
                                        multiple:
                                          _vm.scopefield.configuration
                                            .multiselect,
                                        chips:
                                          _vm.scopefield.configuration.chips,
                                        hint:
                                          _vm.scopefield.configuration
                                            .hint_text,
                                        "persistent-hint": !!_vm.scopefield
                                          .configuration.hint_text,
                                        "prepend-icon":
                                          _vm.scopefield.configuration.icon,
                                        rules: [_vm.rules.required],
                                        readonly:
                                          _vm.scopefield.configuration
                                            .read_only,
                                        "append-icon": _vm.scopefield
                                          .configuration.read_only
                                          ? "lock"
                                          : "arrow_drop_down",
                                        "item-text": "text",
                                        "item-value": "value"
                                      },
                                      on: {
                                        "update:searchInput": function($event) {
                                          _vm.autocompleteSearchText = $event
                                        },
                                        "update:search-input": function(
                                          $event
                                        ) {
                                          _vm.autocompleteSearchText = $event
                                        }
                                      },
                                      model: {
                                        value: _vm.scopevalue.value,
                                        callback: function($$v) {
                                          _vm.$set(_vm.scopevalue, "value", $$v)
                                        },
                                        expression: "scopevalue.value"
                                      }
                                    })
                                  ]
                            ]
                          : _vm.scopefield.type === "select" ||
                            _vm.scopefield.type === "posttype"
                          ? [
                              _c(
                                "v-autocomplete",
                                {
                                  ref: "fieldinput",
                                  attrs: {
                                    "search-input": _vm.autocompleteSearchText,
                                    items: _vm.fieldoptions,
                                    label: _vm.scopefield.name,
                                    required: _vm.scopefield.required,
                                    "single-line": _vm.singleLine,
                                    clearable:
                                      !_vm.scopefield.required &&
                                      !_vm.scopefield.configuration.read_only,
                                    multiple:
                                      _vm.scopefield.configuration.multiselect,
                                    chips: _vm.scopefield.configuration.chips,
                                    hint:
                                      _vm.scopefield.configuration.hint_text,
                                    "persistent-hint": !!_vm.scopefield
                                      .configuration.hint_text,
                                    "prepend-icon":
                                      _vm.scopefield.configuration.icon,
                                    rules: [_vm.rules.required],
                                    readonly:
                                      _vm.scopefield.configuration.read_only,
                                    "append-icon": _vm.scopefield.configuration
                                      .read_only
                                      ? "lock"
                                      : "arrow_drop_down",
                                    "item-text":
                                      _vm.scopefield.type === "posttype"
                                        ? "name"
                                        : "label",
                                    "item-value": "id"
                                  },
                                  on: {
                                    "update:searchInput": function($event) {
                                      _vm.autocompleteSearchText = $event
                                    },
                                    "update:search-input": function($event) {
                                      _vm.autocompleteSearchText = $event
                                    }
                                  },
                                  model: {
                                    value: _vm.scopevalue.value,
                                    callback: function($$v) {
                                      _vm.$set(_vm.scopevalue, "value", $$v)
                                    },
                                    expression: "scopevalue.value"
                                  }
                                },
                                [
                                  _c("div", {
                                    attrs: { slot: "no-data" },
                                    slot: "no-data"
                                  }),
                                  _vm._v(" "),
                                  _vm.iCan("create", "Customers") &&
                                  _vm.scopefield.id === _vm.customerField.id &&
                                  _vm.autocompleteSearchText &&
                                  !_vm.disableAddOption
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "v-list-item v-list-item--link",
                                          attrs: {
                                            slot: "append-item",
                                            role: "listitem"
                                          },
                                          on: { click: _vm.createCustomer },
                                          slot: "append-item"
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "v-list__tile v-list__tile--link theme--light"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "v-list__tile__content"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "v-list__tile__title"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Create as new customer"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm.scopefield.configuration
                                        .allow_custom &&
                                      _vm.autocompleteSearchText
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "v-list-item v-list-item--link",
                                          attrs: {
                                            slot: "append-item",
                                            role: "listitem"
                                          },
                                          on: { click: _vm.createCustomValue },
                                          slot: "append-item"
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "v-list__tile v-list__tile--link theme--light"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "v-list__tile__content"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "v-list__tile__title"
                                                    },
                                                    [_vm._v("Custom value")]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          : _vm.scopefield.type === "status"
                          ? _c(
                              "div",
                              { staticClass: "pa-h" },
                              [
                                !_vm.singleLine
                                  ? [
                                      _c(
                                        "label",
                                        { staticClass: "os-dirty-label" },
                                        [_vm._v(_vm._s(_vm.scopefield.name))]
                                      ),
                                      _c("br")
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "v-menu",
                                  {
                                    attrs: {
                                      disabled:
                                        _vm.scopefield.configuration.read_only
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                      }
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        _vm.keyedLocalOptions &&
                                        _vm.keyedLocalOptions[
                                          _vm.scopevalue.value
                                        ] &&
                                        _vm.scopevalue.value
                                          ? {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                return [
                                                  _c(
                                                    "v-btn",
                                                    _vm._g(
                                                      {
                                                        staticClass: "ma-0",
                                                        attrs: {
                                                          color:
                                                            _vm
                                                              .keyedLocalOptions[
                                                              _vm.scopevalue
                                                                .value
                                                            ].value,
                                                          dark:
                                                            _vm
                                                              .keyedLocalOptions[
                                                              _vm.scopevalue
                                                                .value
                                                            ].configuration
                                                              .white_text,
                                                          disabled:
                                                            _vm.scopefield
                                                              .configuration
                                                              .read_only
                                                        }
                                                      },
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        "\n                                    " +
                                                          _vm._s(
                                                            _vm
                                                              .keyedLocalOptions[
                                                              _vm.scopevalue
                                                                .value
                                                            ].label
                                                          ) +
                                                          "\n                                "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          : _vm.scopefield.configuration
                                              .read_only
                                          ? {
                                              key: "default",
                                              fn: function(undefined) {
                                                return _c(
                                                  "v-btn",
                                                  {
                                                    staticClass: "ma-0",
                                                    attrs: {
                                                      color: "white",
                                                      disabled: ""
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\tNot set\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              }
                                            }
                                          : {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                return [
                                                  _c(
                                                    "v-btn",
                                                    _vm._g(
                                                      {
                                                        staticClass: "ma-0",
                                                        attrs: {
                                                          color: "default",
                                                          disabled:
                                                            _vm.scopefield
                                                              .configuration
                                                              .read_only
                                                        }
                                                      },
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\tNot set\n\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _vm._v(" "),
                                    _c(
                                      "v-list",
                                      { staticClass: "py-0" },
                                      _vm._l(
                                        _vm.scopefield.fieldoptions,
                                        function(option, index) {
                                          return _c(
                                            "v-list-item",
                                            {
                                              key: index,
                                              class: option.value,
                                              attrs: {
                                                dark:
                                                  option.configuration
                                                    .white_text
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.changeStatus(
                                                    option.id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("v-list-item-title", [
                                                _vm._v(_vm._s(option.label))
                                              ])
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                          : _vm.scopefield.type === "file"
                          ? [
                              _c(
                                "v-layout",
                                [
                                  _vm.scopevalue.value &&
                                  _vm.scopevalue.value.url
                                    ? _c(
                                        "v-flex",
                                        {
                                          staticClass: "overflow-hidden mt-4",
                                          class: { "mb-4": _vm.singleLine },
                                          attrs: { xs12: "" }
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "truncate-sub-text",
                                              attrs: {
                                                outlined: "",
                                                "max-width": "100%",
                                                height: "33px"
                                              },
                                              nativeOn: {
                                                click: function($event) {
                                                  _vm.imgDialog = true
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.scopevalue.value
                                                      .filename
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-dialog",
                                            {
                                              attrs: { width: "500" },
                                              model: {
                                                value: _vm.imgDialog,
                                                callback: function($$v) {
                                                  _vm.imgDialog = $$v
                                                },
                                                expression: "imgDialog"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-card",
                                                [
                                                  _c("v-img", {
                                                    attrs: {
                                                      src:
                                                        _vm.scopevalue.value.url
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.scopefield.configuration.read_only
                                    ? _c(
                                        "v-flex",
                                        [
                                          _c("v-file-input", {
                                            ref: "fieldinput",
                                            attrs: {
                                              "hide-input":
                                                _vm.scopevalue.value &&
                                                !!_vm.scopevalue.value.url,
                                              label: _vm.scopefield.name,
                                              required: _vm.scopefield.required,
                                              hint:
                                                _vm.scopefield.configuration
                                                  .hint_text,
                                              "persistent-hint": !!_vm
                                                .scopefield.configuration
                                                .hint_text,
                                              "prepend-icon": _vm.scopefield
                                                .configuration.icon
                                                ? _vm.scopefield.configuration
                                                    .icon
                                                : "mdi-paperclip",
                                              prefix:
                                                _vm.scopefield.configuration
                                                  .prefix,
                                              suffix:
                                                _vm.scopefield.configuration
                                                  .suffix,
                                              counter:
                                                _vm.scopefield.configuration
                                                  .show_counter,
                                              "show-size":
                                                _vm.scopefield.configuration
                                                  .show_size,
                                              chips:
                                                _vm.scopefield.configuration
                                                  .chips,
                                              "single-line": _vm.singleLine,
                                              rules: [_vm.rules.required]
                                            },
                                            model: {
                                              value: _vm.scopevalue.value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.scopevalue,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression: "scopevalue.value"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          : _vm.scopefield.type === "integer"
                          ? [
                              _c("v-text-field", {
                                ref: "fieldinput",
                                attrs: {
                                  label: _vm.scopefield.name,
                                  required: _vm.scopefield.required,
                                  hint: _vm.scopefield.configuration.hint_text,
                                  "persistent-hint": !!_vm.scopefield
                                    .configuration.hint_text,
                                  "prepend-icon":
                                    _vm.scopefield.configuration.icon,
                                  prefix: _vm.scopefield.configuration.prefix,
                                  suffix: _vm.scopefield.configuration.suffix,
                                  counter: _vm.scopefield.configuration
                                    .show_counter
                                    ? _vm.scopefield.configuration.max_length
                                    : null,
                                  "single-line": _vm.singleLine,
                                  readonly:
                                    _vm.scopefield.configuration.read_only,
                                  rules: [
                                    _vm.rules.integer,
                                    _vm.rules.required
                                  ],
                                  "append-icon": _vm.scopefield.configuration
                                    .read_only
                                    ? "lock"
                                    : null
                                },
                                model: {
                                  value: _vm.scopevalue.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.scopevalue,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "scopevalue.value"
                                }
                              })
                            ]
                          : [
                              _c(
                                _vm.scopefield.type === "textarea"
                                  ? "v-textarea"
                                  : _vm.scopefield.type === "file"
                                  ? "v-file-input"
                                  : "v-text-field",
                                {
                                  ref: "fieldinput",
                                  tag: "component",
                                  attrs: {
                                    multiple: "",
                                    label: _vm.scopefield.name,
                                    required: _vm.scopefield.required,
                                    hint:
                                      _vm.scopefield.configuration.hint_text,
                                    "persistent-hint": !!_vm.scopefield
                                      .configuration.hint_text,
                                    "prepend-icon":
                                      _vm.scopefield.configuration.icon,
                                    prefix: _vm.scopefield.configuration.prefix,
                                    suffix: _vm.scopefield.configuration.suffix,
                                    counter: _vm.scopefield.configuration
                                      .show_counter
                                      ? _vm.scopefield.configuration.max_length
                                      : null,
                                    "single-line": _vm.singleLine,
                                    readonly:
                                      _vm.scopefield.configuration.read_only,
                                    rules: [
                                      _vm.rules.decimal,
                                      _vm.rules.email,
                                      _vm.rules.integer,
                                      _vm.rules.url,
                                      _vm.rules.required,
                                      _vm.rules.max_length
                                    ],
                                    "append-icon": _vm.scopefield.configuration
                                      .read_only
                                      ? "lock"
                                      : null
                                  },
                                  model: {
                                    value: _vm.scopevalue.value,
                                    callback: function($$v) {
                                      _vm.$set(_vm.scopevalue, "value", $$v)
                                    },
                                    expression: "scopevalue.value"
                                  }
                                }
                              )
                            ]
                      ],
                      2
                    )
              ]
            )
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e88f982", { render: render, staticRenderFns: staticRenderFns })
  }
}